import { render, staticRenderFns } from "./industry.vue?vue&type=template&id=ab35047e&scoped=true&"
import script from "./industry.vue?vue&type=script&lang=js&"
export * from "./industry.vue?vue&type=script&lang=js&"
import style0 from "./industry.vue?vue&type=style&index=0&id=ab35047e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab35047e",
  null
  
)

export default component.exports